module.exports = __webpack_public_path__ + "img/bbva-despegar.d47a74f1.svg";